import { useCallback, useState } from "react";

interface UseDisclosureReturn {
    isOpen: boolean;
    onClose: () => void;
    onOpen: () => void;
    onToggle: () => void;
}

export const useDisclosure = (initialState = false):UseDisclosureReturn => {
    const [isOpen, setIsOpen] = useState(initialState);

    const onClose = useCallback(() => setIsOpen(false), []);

    const onOpen = useCallback(() => setIsOpen(true), []);

    const onToggle = useCallback(() => setIsOpen((prevIsOpen) => !prevIsOpen), []);

    return {
        isOpen,
        onClose,
        onOpen,
        onToggle,
    };
}